import { useEffect } from 'react';
import { Prototype3Provider, usePrototype3 } from './Prototype3Context';
import Screen01Welcome from './screens/Screen01Welcome';
import Screen02DraftBuilder from './screens/Screen02DraftBuilder';

const ScreenSwitch = () => {
  const { currentScreen } = usePrototype3();
  switch (currentScreen) {
    case '01-welcome':
      return <Screen01Welcome />;
    case '02-draft-builder':
      return <Screen02DraftBuilder />;
    default:
      return null;
  }
};

const TAILWIND_SCRIPT_ID = 'prototypes-tailwind-cdn';
const INTER_LINK_ID = 'prototypes-inter-font';
const HIDE_APP_CHROME_STYLE_ID = 'prototypes-hide-app-chrome';

const Prototype3Page = () => {
  useEffect(() => {
    const tw = document.createElement('script');
    tw.id = TAILWIND_SCRIPT_ID;
    tw.src = 'https://cdn.tailwindcss.com';
    tw.onload = () => {
      const w = window as unknown as { tailwind?: { config?: Record<string, unknown> } };
      if (w.tailwind) {
        w.tailwind.config = { corePlugins: { preflight: false } };
      }
    };

    const inter = document.createElement('link');
    inter.id = INTER_LINK_ID;
    inter.rel = 'stylesheet';
    inter.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap';

    const hideAppChrome = document.createElement('style');
    hideAppChrome.id = HIDE_APP_CHROME_STYLE_ID;
    hideAppChrome.textContent = '.footer { display: none !important; }';

    document.head.append(tw, inter, hideAppChrome);

    return () => {
      document.getElementById(TAILWIND_SCRIPT_ID)?.remove();
      document.getElementById(INTER_LINK_ID)?.remove();
      document.getElementById(HIDE_APP_CHROME_STYLE_ID)?.remove();
    };
  }, []);

  return (
    <Prototype3Provider>
      <div className="tw relative w-full h-full overflow-hidden">
        <ScreenSwitch />
      </div>
    </Prototype3Provider>
  );
};

export default Prototype3Page;
